import { defineStore } from 'pinia'
import { useSyncableModel } from '@/composables/useSyncableModel.js'
import { useApiResource } from '@/composables/resources/useApiResource.js'
import Harvest from '@/models/Harvest.js'

export const useHarvestStore = defineStore('harvestStore', () => {
  let syncableModel = useSyncableModel(useApiResource('harvests'), {
    className: Harvest.modelName.name,
    paramKey: Harvest.modelName.paramKey
  })

  function findByFarmUuid(farm_uuid) {
    let items = syncableModel.collection.value.filter((e) => e.farm_uuid == farm_uuid)
    return items
  }

  function $reset() {
    syncableModel.collection.value = []
  }

  return {
    ...syncableModel,
    findByFarmUuid,
    $reset
  }

}, {
  persist: true
})

